module.exports = __webpack_public_path__ + "img/frx.ffde7cfe.png";